import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PositionManagementLayer from "../components/PositionManagementLayer";

const PositionManagementPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Position Management" />
        <PositionManagementLayer />
      </MasterLayout>
    </>
  );
};

export default PositionManagementPage;
